module.exports = __webpack_public_path__ + "img/01.67584e73.png";